import { createFileRoute } from "@tanstack/react-router";
import { lazy } from "react";
const AdminReviewsPage = lazy(() => import("@/pages/admin/AdminReviews"));

export const Route = createFileRoute("/admin/reviews")({
  component: AdminReviewsPage,
});
